// src/Icons/GaussIcon.jsx
import React from 'react';

const GaussIcon = ({ size = 55, className = '' }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
   
    {/* Column lines */}
    <line x1="10" y1="10" x2="10" y2="90" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="90" y1="10" x2="90" y2="90" stroke="#f3f4f6" strokeWidth="6" />
    {/* Row lines */}
    <line x1="10" y1="13" x2="20" y2="13" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="10" y1="87" x2="20" y2="87" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="90" y1="13" x2="80" y2="13" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="90" y1="87" x2="80" y2="87" stroke="#f3f4f6" strokeWidth="6" />

    {/* Right side (solution vector) */}
    <line x1="70" y1="20" x2="70" y2="80" stroke="#f3f4f6" strokeWidth="4" />

    <circle cx="80" cy="30" r="5" fill="#f3f4f6" />
    <circle cx="80" cy="50" r="5" fill="#f3f4f6" />
    <circle cx="80" cy="70" r="5" fill="#f3f4f6" />
    <circle cx="60" cy="70" r="5" fill="#f3f4f6" />
    <circle cx="60" cy="50" r="5" fill="#f3f4f6" />
    <circle cx="60" cy="30" r="5" fill="#f3f4f6" />
    <circle cx="40" cy="30" r="5" fill="#f3f4f6" />
    <circle cx="40" cy="50" r="5" fill="#f3f4f6" />
    <circle cx="20" cy="30" r="5" fill="#f3f4f6" />
  </svg>
);

export default GaussIcon;
